/** @typedef {string} LaunchDarklyFlagKey */

/** Account-wide activity stream (sidebar nav + /activity page). */
export const LD_FLAG_ACCOUNT_ACTIVITY_STREAM = "idea-MDP-404";

/** MDP-464 / ER-9266 — Responsibility form "Attachment to Roles" tab and the
 *  "Active Responsibilities attached to nothing" banner on the Responsibilities list. */
export const LD_FLAG_IDEA_MDP_464 = "idea-MDP-464";

/** MDP-432 — Settings module (elevated-nav gate; also gates /settings/configuration
 *  and future /settings/* routes via the router's handleDashboardAndMdp432Guard). */
export const LD_FLAG_IDEA_MDP_432 = "idea-MDP-432";

/** MDP-428 / ER-8057 — Performance KPIs: Add KPI Draft (create_kpi_draft entry point).
 *  Off by default; the Performance KPIs page gates the Add-KPI flow behind this. */
export const LD_FLAG_IDEA_MDP_428 = "idea-MDP-428";

/** Positions pane: search + drag-drop attach (roles / resp / checkpoints). */
export const LD_FLAG_DRAG_DROP_ATTACH_ORG_OBJECTS_POSITION_TREE_VIEW = "idea-MDP-434";

/** ER-9119 / animated readiness standing dots (Given square, Obsolete+Current pulse). */
export const LD_FLAG_IDEA_MDP_453_ANIMATED_READINESS_STANDING_DOTS = "idea-MDP-453";

/** MDP-276 / admin impersonation (start handoff, account banner, end session). */
export const LD_FLAG_IDEA_MDP_276_IMPERSONATION = "idea-MDP-276";

/** MDP-503 / ER-10317 — in-account Admin View-as / Preview (Employees row actions, banner, exit). */
export const LD_FLAG_IDEA_MDP_503_VIEW_AS = "idea-MDP-503";

/** Responsibility page / directory — show Context tab when true. */
export const LD_FLAG_CONTEXT_TAB_RESPONSIBILITY_PAGE = "context-tab-responsibility-page";

/** MDP-494 / ER-9892 — Entity Context: render the new ContextTab (else the legacy purpose UI) on the org-object cards. */
export const LD_FLAG_IDEA_MDP_494 = "idea-MDP-494";

/** MDP-495 / ER-10337 — Disable invalid (is_invalid) Positions in the assignment position picker.
 *  Kill switch: enabled by default; set to false to restore legacy behavior (invalid
 *  positions shown selectable — the backend assign-gate still rejects them).
 *  ER-9940 — also gates the red invalid-assignment indicators (positions list chip, tree label +
 *  tooltip reason, attached-roles name); off restores the previous rendering. */
export const LD_FLAG_IDEA_MDP_495 = "idea-MDP-495";

/** MDP-270 / force obsolete and restore badge from badge chatter (Organization only). */
export const LD_FLAG_MDP_270_HANDLE_OBSOLETE_BADGES = "idea-MDP-270";
/** MDP-440 / DepartmentTagInPositionForm + DepartmentPickerDialog in PositionPageHeader. */
/** MDP-487 / generate pre-signed video upload URL before opening upload dialog. */
export const LD_FLAG_IDEA_MDP_487 = "idea-MDP-487";
/** MDP-440 / FilterPositionsModal (pane) + DepartmentTagInPositionForm + Departments tab. */
export const LD_FLAG_IDEA_MDP_440 = "idea-MDP-440";

/** ER-10029 / hide "Top of OrgChart" chip in PositionPageHeader. */
export const LD_FLAG_IDEA_MDP_450 = "idea-MDP-450";

/** ER-12856 / Positions History tab in EmployeeTabBar (existing flag, previously a literal). */
export const LD_FLAG_EMPLOYEE_POSITION_HISTORY_VIEW = "employee-position-history-view";

/** ER-9863 / OperatingCountriesTable: default-first sort, add-country event, hide menu on default row. */
export const LD_FLAG_IDEA_MDP_506 = "idea-MDP-506";

/** Instructions banner + menu tab in CheckpointEditMenu (checkpoint edit form). */
export const LD_FLAG_INSTRUCTIONS_BANNER_IN_CHECKPOINT_EDIT_FORM =
  "instructions-banner-in-checkpoint-edit-form";

/** MDP-522 / ER-10129 — admin notifications feature (ToastContainer + account-action toasts). */
export const LD_FLAG_IDEA_MDP_522 = "idea-MDP-522";

/** MDP-636 / ER-12514 — Position Card redesign and capacity trigger (PositionDepartment, PositionCapacityTrigger, PositionCard). */
export const LD_FLAG_IDEA_MDP_636 = "idea-MDP-636";

/** MDP-546 / ER-10458 — All Tasks: top-level Tasks side-menu item + /tasks route. */
export const LD_FLAG_IDEA_MDP_546 = "idea-MDP-546";

/** MDP-611 / ER-12006 — AccessStatusBadge invite stages (Rule 7.2), attention dot (Rule 7.3)
 *  and caller-supplied tooltip. Flag off = the badge renders as before. */
export const LD_FLAG_IDEA_MDP_611 = "idea-MDP-611";

/** MDP-610 / ER-11921 — OrgObjectChipButton component (Org Object Badge work). */
export const LD_FLAG_IDEA_MDP_610 = "idea-MDP-610";

/** MDP-523 — Role/Department/Responsibility/Position Context tab: numeric count badge (files + context text) instead of boolean "+" badge. */
export const LD_FLAG_IDEA_MDP_523 = "idea-MDP-523";

/** MDP-526 / Per-Access filter persistence — shared mechanism (Access-scoped storage + defaults registry). */
export const LD_FLAG_IDEA_MDP_526 = "idea-MDP-526";

/** MDP-457 / ER-11130 — EmployeeModal: hide Master; Coach only when acting user is Master + master_will_coach. */
export const LD_FLAG_IDEA_MDP_457 = "idea-MDP-457";

/** MDP-452 / ER-10765 — New Checkpoint Edit and Inspection (edit v2, criteria_body.en lowercase on draft save). */
export const LD_FLAG_IDEA_MDP_452 = "idea-MDP-452";

/** ER-10901 / Filter Modal Standard — FilterRolesModal (Status/Archived/Validity/Positions/In-use/Timeline) on the Roles list; off → legacy SearchModal. */
export const LD_FLAG_IDEA_MDP_572 = "idea-MDP-572";

/** MDP-556 / ER-11183 — Employees List header dashboard (4 filter-aware stat cards). */
export const LD_FLAG_IDEA_MDP_558 = "idea-MDP-558";

/** MDP-556 / ER-12532 — Employees List header dashboard (5 filter-aware stat cards), gated independently of idea-MDP-558. */
export const LD_FLAG_IDEA_MDP_556 = "idea-MDP-556";

/** MDP-557 / ER-12533 — Positions List header dashboard (4 filter-aware stat cards), gated independently of idea-MDP-558. */
export const LD_FLAG_IDEA_MDP_557 = "idea-MDP-557";

/** MDP-639 / ER-12536 — Responsibilities List header dashboard (5 filter-aware stat cards), gated independently of idea-MDP-558. */
export const LD_FLAG_IDEA_MDP_639 = "idea-MDP-639";

/** MDP-641 / ER-12649 — Appointed badges: admin "Appoint as" action and Rule 17 self-appointment prompt on checkpoint activation. */
export const LD_FLAG_IDEA_MDP_641 = "idea-MDP-641";

/** MDP-632 / ER-12382 — Badge status model: status (Good Standing, Obsolete, Expired, Upgraded, Revoked) and issuing method (Given, Awarded) on badges and badge holder tables. */
export const LD_FLAG_IDEA_MDP_632 = "idea-MDP-632";

/** MDP-583 / ER-12314 — Async Chat MVP: combined Chatter drawer (header, All/Comments/History filter, day-grouped feed). */
export const LD_FLAG_IDEA_MDP_583 = "idea-MDP-583";

/** MDP-514 / ER-10686 — Departments List header dashboard (4 filter-aware stat cards). */
export const LD_FLAG_IDEA_MDP_514 = "idea-MDP-514";

/** MDP-551 / ER-10492 — Employees list radio filter groups (Occupies, Profile Picture, Access, Prepares) on FilterEmployeeModal. */
export const LD_FLAG_IDEA_MDP_551 = "idea-MDP-551";

/** MDP-552 / ER-10506 — Readiness > Employees filter bar (Rule 5): remove the Recalculation
 *  radio and add the Excluded (exclude_from_avg) radio + Department picker with scope toggle.
 *  Off → legacy Recalculation-only SearchModal filter bar is preserved.
 *  MDP-552 / ER-10503 — also gates the Readiness > Positions tab (same idea, same flag). */
export const LD_FLAG_IDEA_MDP_552 = "idea-MDP-552";

/** MDP-560 / ER-10598 — consistent skeleton loading across exIQtive tables.
 *  Skeleton block (Vuetify v-skeleton-loader) shown while the initial fetch is in flight,
 *  replacing the empty-state/blank flash. Off → legacy empty-state flash is preserved. */
export const LD_FLAG_IDEA_MDP_560 = "idea-MDP-560";

/** ER-11180 / PositionRolesAndResponsibilitiesDraggableTree — new draggable tree + More filters / IQ Suggest / impersonation-blocked flow.
 *  Kill switch: renders by default; set to false to hide the new tree until consumers wire it behind the flag. */
export const LD_FLAG_POSITION_ROLES_RESPONSIBILITIES_TREE =
  "position-roles-responsibilities-draggable-tree";

/** MDP-429 / ER-11690 — AI-assisted Pay Range First Draft wizard (Suggest Range panel).
 *  Rollout gate: hidden by default; enable the flag to show "Suggest Range" on Step 1. */
export const LD_FLAG_IDEA_MDP_429 = "idea-MDP-429";

/** MDP-429 / ER-11230 — version-navigation chevrons on PayRangeSubscriptionCard (Fair Pay Rule 5). */
export const LD_FLAG_FAIR_PAY_VERSION_NAVIGATION = "fair-pay.version-navigation";

/** MDP-429 / ER-11229 — subscription-navigation chevrons on PositionsWithPayRangeSubscriptionsTable (Fair Pay Rule 4). */
export const LD_FLAG_FAIR_PAY_SUBSCRIPTION_NAVIGATION = "fair-pay.subscription-navigation";

/** ER-11727 — LocationPicker component for Fair Pay geographic scope selection (country/region/metro/county). */
export const LD_FLAG_FAIR_PAY_LOCATION_PICKER = "fair-pay.location-picker";

/** ER-10611 / Organization > Employees list — multi-field search dropdown (name / primary position / preparing for).
 *  Kill switch: renders by default; set to false to hide the multi-field box and fall back to the simple search input. */
export const LD_FLAG_EMPLOYEE_MULTI_FIELD_SEARCH = "employee-multi-field-search";

/** ER-11265 / IQThinkingBanner — live elapsed-time counter next to the thinking title.
 *  Kill switch: renders by default; set to false to hide the elapsed counter. */
export const LD_FLAG_IQ_THINKING_BANNER_ELAPSED_TIME = "iq-thinking-banner-elapsed-time";

/** MDP-578 / ER-11070 — VideoWithChaptersView learner-facing video-with-TOC surface
 *  (video player + chapter-segmented scrub bar + chapters list + Summary card).
 *  Kill switch: renders by default; set to false to hide the new surface until
 *  consumers wire it behind the flag. */
export const LD_FLAG_VIDEO_WITH_CHAPTERS_VIEW = "idea-MDP-578";

/** MDP-579 / ER-11081 + ER-11082 — Show Readiness (ReadinessCircle) in the Employee ↔ Position
 *  Assignment Cards (PrimaryPositionAssignmentCard + PreparingForPositionAssignmentCard).
 *  Rollout gate: the circle is hidden until the flag is enabled; the readiness data
 *  binding is shipped separately from the visual component. */
export const LD_FLAG_IDEA_MDP_579 = "idea-MDP-579";

/** MDP-569 / ER-10810 — every interactive element on the Employee ↔ Position Assignment
 *  cards (PrimaryPositionAssignmentCard) is a real button/link with a tooltip.
 *  Rollout gate: off by default → the card keeps its legacy markup. */
export const LD_FLAG_IDEA_MDP_569 = "idea-MDP-569";

/** MDP-592 / ER-11310 + ER-11307 — Inspections surface of the Checkpoint detail view:
 *  InspectionsTableByVersionFilterModal and the CheckpointInspectionsTab (Inspections tab
 *  + bulk-reset button).
 *  Kill switch: renders by default; set to false to keep the filter modal closed and the
 *  Inspections tab hidden. */
export const LD_FLAG_IDEA_MDP_592 = "idea-MDP-592";

/** MDP-570 / ER-10831 — Owner/Co-Owner-initiated password reset (Settings > Users "..." menu). */
export const LD_FLAG_IDEA_MDP_570 = "idea-MDP-570";

/** MDP-566 / ER-11346 + ER-11356 — Job Categories (Organization > Job Categories):
 *  JobCategoriesList table view and the AddJobCategoryWizard both render behind this
 *  kill switch (default on). Set to false to hide the new table/wizard until the
 *  Organization screen wires them behind the flag. */
export const LD_FLAG_IDEA_MDP_566 = "idea-MDP-566";

/** MDP-595 / ER-11376 — AddOperatingLanguageDialog (Configuration > Languages add-language dialog).
 *  Kill switch: renders by default; set to false to keep the dialog closed until
 *  the Languages settings screen wires it behind the flag. */
export const LD_FLAG_IDEA_MDP_595 = "idea-MDP-595";

/** MDP-577 / ER-11064 — IQ suggest-responsibilities transcript (create/reject chat messages + overlay layout). */
export const LD_FLAG_IDEA_MDP_577 = "idea-MDP-577";

/** MDP-585 / ER-11387 — Direct Responsibility Attachment to a Position
 *  and AI-assisted job-description import. Also the rollout gate for the new
 *  attached-roles draggable tree. Off by default → legacy OrganizationRolesTable. */
export const LD_FLAG_IDEA_MDP_585 = "idea-MDP-585";

/** MDP-581 / ER-11386 / ER-11516 — Job Families (Organization > Job Families):
 *  JobFamiliesList and the Organization tab render behind this kill switch
 *  (list default on; Organization page tab off until the flag is enabled). */
export const LD_FLAG_IDEA_MDP_581 = "idea-MDP-581";

/** MDP-598 / ER-11467 — Readiness levels of responsibility assignments:
 *  admin warning before saving a Role/Responsibility assignment at importance=0
 *  (Visibility rule safeguard). Kill switch: enabled by default; set to false to
 *  skip the zero-importance confirmation dialog. */
export const LD_FLAG_IDEA_MDP_598 = "idea-MDP-598";

/** MDP-599 / ER-11469 — Your Stuff floating AI Assistant button (fixed bottom-right pill
 *  that opens the IQ AI Assistant overlay). Kill switch: enabled by default; set to false
 *  to hide the floating button. */
export const LD_FLAG_IDEA_MDP_599 = "idea-MDP-599";

/** MDP-600 / ER-11477 — AddOnboardingStepDialog (Employee Onboarding Program step creation).
 *  Kill switch: renders by default; set to false to keep the dialog closed until an
 *  Onboarding steps list or wizard wires it behind the flag. */
export const LD_FLAG_IDEA_MDP_600 = "idea-MDP-600";

/** MDP-601 / ER-11480 — admin portal side menu "Onboarding" nav item (flat link).
 *  Kill switch: renders by default; set to false to hide the Onboarding nav item
 *  (e.g. until its destination admin page/route is confirmed with product). */
export const LD_FLAG_IDEA_MDP_601 = "idea-MDP-601";

/** MDP-621 / ER-12245 — Role-based invite onboarding wizards (shared shell + Welcome /
 *  Set your profile / Earn your readiness badges steps). Rollout gate: the wizard
 *  shell renders by default; set to false to hide the new onboarding wizards and fall
 *  through to the existing post-login landing redirect. Also ER-12247 — Settings > Users >
 *  Add user "Also invite as an employee" checkbox. Also ER-12250 — gates the
 *  "Reset Welcome wizard" row in the Settings > Users menu. */
export const LD_FLAG_IDEA_MDP_621 = "idea-MDP-621";

/** MDP-51 / ER-12757 — Settings > Integrations: account-level status with Owner/Co-Owner-only
 *  actions and a read-only view (lock notice) for other admins. Off: legacy placeholder list. */
export const LD_FLAG_IDEA_MDP_51 = "idea-MDP-51";

/** MDP-646 / ER-12755 — Settings > Integrations: Microsoft Teams card (connection states, consent link,
 *  rollout checklist, reachable employees). Off: the card does not render. */
export const LD_FLAG_IDEA_MDP_646 = "idea-MDP-646";

/** MDP-605 / ER-11757 — Settings > Configurations > Readiness panel
 *  (automatically_remove_given_badges). Kill switch: the tile and its configuration
 *  page render by default; set the flag to false to hide them. */
export const LD_FLAG_IDEA_MDP_605 = "idea-MDP-605";

/** MDP-627 / ER-12306, ER-12307 — Account Adoption: the Adoption tab on the Admin Portal
 *  account page (ER-12306) and the Settings > Adoption scoring page (ER-12307: score
 *  weights, action weights, score scaling, bands, signal rules, version history, impact
 *  preview). Fail-closed: both surfaces stay hidden until the flag resolves true; the
 *  Settings page is additionally restricted to platform super-users. */
export const LD_FLAG_IDEA_MDP_627 = "idea-MDP-627";

/** MDP-604 / ER-11752 — Article Checkpoint "Import from Scribe" entry point + dialog.
 *  Kill switch: renders by default; set to false to hide the overflow-menu item and
 *  keep the Scribe import dialog closed. */
export const LD_FLAG_IDEA_MDP_604 = "idea-MDP-604";

/** MDP-630 / ER-12394 — Article Checkpoint "Import from PDF" entry point + dialog.
 *  Rollout gate: the overflow-menu item stays hidden until the flag resolves true. */
export const LD_FLAG_IDEA_MDP_630 = "idea-MDP-630";

/** MDP-633 / ER-12400 — Article Checkpoint "Import from Word" entry point + dialog.
 *  Rollout gate: the overflow-menu item stays hidden until the flag resolves true. */
export const LD_FLAG_IDEA_MDP_633 = "idea-MDP-633";

/** MDP-586 / ER-11208 — Checkpoint history icon hover tooltip ("What changed").
 *  Kill switch: when false, the history icon shows no hover tooltip (legacy behavior). */
export const LD_FLAG_IDEA_MDP_586 = "idea-MDP-586";

/** MDP-575 / ER-11573 — Tasks module: sidebar Tasks + Your Stuff > Your Tasks, and
 *  TaskEmployeeToUploadVideoDialog access-less assignee list. Off → hide Tasks nav
 *  and keep the legacy access-holders-only assign list. */
export const LD_FLAG_IDEA_MDP_575 = "idea-MDP-575";

/** MDP-461 / ER-11861 — deadline / done-on date line under the Your Tasks status badge.
 *  Kill switch: renders by default; set to false to hide the date line. */
export const LD_FLAG_IDEA_MDP_461 = "idea-MDP-461";

/** MDP-517 / ER-10101 — Settings > Configurations > Notifications panel (digest_enabled +
 *  digest_readiness_threshold). Fail-closed: the tile and its configuration page stay
 *  hidden until the flag resolves true. */
export const LD_FLAG_IDEA_MDP_517 = "idea-MDP-517";

/** MDP-483 / ER-12237 — Settings > Configurations > Branding panel (tile + page shell).
 *  Fail-closed: the tile and its configuration page stay hidden until the flag resolves
 *  true. The logo control itself ships separately (ER-12238). */
export const LD_FLAG_IDEA_MDP_483 = "idea-MDP-483";

/** MDP-176 / ER-11510 — As Employee unified Inspection Requests table
 *  (AsEmployeeInspectionRequestsTable): showing every status by default
 *  (not just Pending/Accepted) and the new per-row "Prepare" action.
 *  Off by default → legacy Pending/Accepted-only view, no Prepare button.
 *
 *  Also used by AsACoachMenu (ER-11505/ER-11508) as a kill switch: the coach
 *  Pending/Accepted/History tabs render by default and hide only when this
 *  flag explicitly resolves false. */
export const LD_FLAG_IDEA_MDP_176 = "idea-MDP-176";

/** MDP-606 / ER-11800 — ActivityStreamCard name-first readable card (ID chip,
 *  counterpart link, text-only type lozenge, "Older entry" hint). Off by default
 *  → the legacy card (object_descriptor + Legacy tag) keeps rendering unchanged. */
export const LD_FLAG_IDEA_MDP_606 = "idea-MDP-606";

/** MDP-608 / ER-11899 — shared inline org-object name validation (live uniqueness
 *  check, one copy string, no toasts). Off by default: the composable is a no-op
 *  until the flag resolves true, so the legacy (no inline check) behaviour stays. */
export const LD_FLAG_IDEA_MDP_608_ORG_OBJECT_NAME_VALIDATION = "idea-MDP-608";

/** MDP-582 — IQ Side Panel: docked IQSidePanel from the main sidebar AI Assistant
 *  button, and Comment Posted thread (user bubble + IQ reply). Rollout gate: off by
 *  default → AI Assistant opens the full IQ overlay; when on → docked side panel. */
export const LD_FLAG_IDEA_MDP_582 = "idea-MDP-582";

/** MDP-609 / ER-11913 — Employee detail page Dashboard tab body
 *  (EmployeeReadinessDashboard: Readiness Map, Readiness over time chart,
 *  Responsibilities + Badges count-by-level cards, parameterized by the viewed
 *  employee). Off → the legacy stub ("Dashboard" PageHeaderWithButton) renders.
 *
 *  MDP-609 / ER-11912 — the same flag also gates the "Dashboard" tab of the
 *  Employee detail page horizontal menu (hidden by default). */
export const LD_FLAG_IDEA_MDP_609 = "idea-MDP-609";

/** MDP-617 / ER-12072 — AddRoleDialog "Context" field + IQ "Suggest context"
 *  stream (Role creation modal). Off → the legacy name-only dialog renders. */
export const LD_FLAG_IDEA_MDP_617 = "idea-MDP-617";

/** MDP-616 — Admin Products tab: turn Readiness off (confirm modal + API toggle). */
export const LD_FLAG_IDEA_MDP_616 = "idea-MDP-616";

/** MDP-545 / ER-12214 — IQ Ask AI structured account-data answers
 *  ({text, blocks[], sources[]} rendering: entity lists, source links, View all,
 *  snapshot date + Refresh). Off by default → structured Ask AI blocks do not render. */
export const LD_FLAG_IDEA_MDP_545 = "idea-MDP-545";
/** MDP-619 / ER-12184 — Partner Portal MVP (partners.exiqtive.com):
 *  PartnerClientUsersTable component and related Partner Portal components.
 *  Off by default → Partner Portal features hidden until enabled. */
export const LD_FLAG_IDEA_MDP_619 = "idea-MDP-619";

/** MDP-622 / ER-12266 — Organization Dashboard "Active Departments" count tile,
 *  and MDP-622 / ER-12270 — Organization Dashboard "Recent activity" card.
 *  Always shown regardless of the Readiness product (Organization is independent
 *  of Readiness). Kill switch: renders by default; set to false to hide.
 *  MDP-622 / ER-12272 — "Organization health" card: fail-closed, hidden until the
 *  flag resolves true (the v2 organization-health route answers 404 while off). */
export const LD_FLAG_IDEA_MDP_622 = "idea-MDP-622";
/** MDP-624 / ER-12285 — Admin Products tab: six rows with descriptions and the
 *  released-product rule (Knowledge/Engagement rows locked, last released product lock).
 *  Kill switch: renders by default; set to false to keep the legacy four-row layout. */
export const LD_FLAG_IDEA_MDP_624 = "idea-MDP-624";
/** MDP-625 / ER-12606 — Admin Products tab: Knowledge is a released product (switch
 *  editable while Readiness is on; Readiness locked while Knowledge is on).
 *  Kill switch: released by default; set to false to keep Knowledge locked as "Not yet available".
 *  MDP-625 / ER-12584 — Complete Checkpoint drawer: "Checkpoint passed" result step for
 *  quiz-only checkpoints. Fail-closed: the step is absent until the flag resolves true. */
export const LD_FLAG_IDEA_MDP_625 = "idea-MDP-625";

/** MDP-509 / ER-10044 — Vue 3 migration rollout gate. Also gates the DepartmentCard
 *  readiness scope toggle (new behaviour bundled into the migrated DepartmentCard). */
export const LD_FLAG_IDEA_MDP_509 = "idea-MDP-509";
/** MDP-615 / ER-12039 — Organization > Positions "Categorized" list view
 *  (Department / Job Category / Job Family columns editable from the row).
 *  Rollout gate: the Categorized segment is hidden until the flag resolves true
 *  AND at least one categorization column is visible. */
export const LD_FLAG_IDEA_MDP_615 = "idea-MDP-615";

/** MDP-626 / ER-12288 — Organization > Responsibility > Badge Holders: "Add Badge Holder"
 *  opens the As Coach "Inspect" checklist in a right drawer (checkpoint panel stacked in a
 *  second drawer) instead of the legacy ChecklistInspectionRightPane. Off → legacy pane. */
export const LD_FLAG_IDEA_MDP_626 = "idea-MDP-626";

/**
 * Organization sub-tab header dashboard flags — single source of truth for both
 * the LaunchDarkly key and the matching Vuex `featureFlags` getter name. The
 * getter names used to be hand-typed per consumer (root cause of the header
 * dashboard flag mis-wiring in ER-11490); a flag change is now a one-line edit
 * here.
 */
export const HEADER_DASHBOARD_FLAGS = Object.freeze({
  employees: {
    launchDarklyKey: "idea-MDP-556",
    storeGetter: "featureFlags/ideaMDP556",
  },
  positions: {
    launchDarklyKey: "idea-MDP-557",
    storeGetter: "featureFlags/ideaMDP557",
  },
  departments: {
    launchDarklyKey: "idea-MDP-514",
    storeGetter: "featureFlags/ideaMDP514",
  },
  responsibilities: {
    launchDarklyKey: "idea-MDP-639",
    storeGetter: "featureFlags/ideaMDP639",
  },
});

/** MDP-631 / ER-12369 — Help menu (User Guide link) in the page header. */
export const LD_FLAG_IDEA_MDP_631 = "idea-MDP-631";

/** MDP-614 / ER-12025 — effective-dated Status + State display and Effective from/to period fields. */
export const LD_FLAG_IDEA_MDP_614 = "idea-MDP-614";

/** MDP-423 / ER-12664 — Procedures MVP (Procedures module routes, Procedure Books table). */
export const LD_FLAG_IDEA_MDP_423 = "idea-MDP-423";

/** MDP-645 / ER-12759 — Employee > Timeline tab (Occupies and Prepares for). Off by default; no UI consumes it yet. */
export const LD_FLAG_IDEA_MDP_645 = "idea-MDP-645";

/** MDP-647 / ER-12771 — PositionCapacityAttachmentsBadge (position picker rows). Off by default; the picker row (ER-12772) is the consumer that gates it. */
export const LD_FLAG_IDEA_MDP_647 = "idea-MDP-647";

/** MDP-648 / ER-12790 — Inspection protocol editor redesign: InspectionStepEditorCard (Step n header, edit/delete icons, drag handle) with the shared InspectionStepBody. Off → legacy InstructionStepCard rows. */
export const LD_FLAG_IDEA_MDP_648 = "idea-MDP-648";

/** MDP-649 / ER-12813, ER-12815, ER-12816 — As Employee Complete Checkpoint drawer redesign. ER-12813: coach-style header (responsibility chip + Checkpoint criteria row). ER-12815: quiz question cards in the As a Coach inspection style (QuizQuestionCard v2). ER-12816: video and article steps render inside LessonStepCard and record Video seen / Article seen. Off → classic header and legacy card/body. */
export const LD_FLAG_IDEA_MDP_649 = "idea-MDP-649";

/** MDP-650 / ER-12834 — Phone browser shell: below the tablet breakpoint the signed-in layout drops the side menu for a minimal Your Tasks / Profile header, and every other route shows an unsupported-screen state. Off → legacy "Desktop only" message. */
export const LD_FLAG_IDEA_MDP_650 = "idea-MDP-650";

/** MDP-652 / ER-12862, ER-12863, ER-12864 — Date picker fast month and year navigation (DatePickerPeriodCell, DatePickerHeader, DatePickerMonthGrid). Off by default; the date picker menu (ER-12866) is the consumer that gates it. */
export const LD_FLAG_IDEA_MDP_652 = "idea-MDP-652";

/** MDP-651 / ER-12861 — Employee > Path to Readiness: Inspect a responsibility opens the inline As Coach checklist (AsCoachInspectWorkspace) instead of the legacy EvalResponsibilityModal / Organization inspection route. Off → current behaviour. */
export const LD_FLAG_IDEA_MDP_651 = "idea-MDP-651";
